/* jshint esversion: 6 */

var consoleSignatureStyle =
	"font-size: 16px;" +
	"background: #F7F2DF;" +
	"color: #4A4A4A;" +
	"text-align: center;" +
	"padding: 10px 15px;" +
	"width: 100%;" +
	"border-radius: 20px;";

var consoleSignatureText = "%cUtviklet av Aptum";

console.log(consoleSignatureText, consoleSignatureStyle);

jQuery(function() {

	if ( jQuery( 'body' ).hasClass( 'blog' ) ) {
		jQuery( 'h1' ).each(function() {
			var me = jQuery( this );
			me.html( me.text().replace( /(^\w+)/, '<strong>$1</strong>' ) );
		});
	}
	if ( jQuery( 'body' ).hasClass( 'woocommerce' ) ) {
		jQuery( 'h1' ).each(function() {
			var me = jQuery( this );
			me.html( me.text().replace( 'produkter', '<strong>produkter</strong>' ) );
		});
	}
	/* Fix add-to-cart custom fields style and add redirect params for /finn-vekt */
	if ( jQuery('.wc-pao-addon-bat-merke-modell').length || jQuery('.wc-pao-addon-bat-lengde').length ) {
		jQuery('.wc-pao-addon-bat-merke-modell, .wc-pao-addon-bat-lengde').each( function() {
			var labelText = jQuery(this).children('label').text();
			jQuery(this).children('label').remove();
			jQuery(this).find('input').attr( 'placeholder', labelText );
		});
		jQuery('.wc-pao-addons-container').css( 'display', 'flex' );
		jQuery('a#weightcalc').click(function(e) {
			e.preventDefault();
			var href = this.href;
			var params = 'baatmodell=' + jQuery('.wc-pao-addon-container.wc-pao-addon-bat-merke-modell input').val() + '&baatlengde=' + jQuery('.wc-pao-addon-container.wc-pao-addon-bat-lengde input').val();
			if (href.indexOf('?') != -1) {
				href = href + '&' + params;
			}
			else {
				href = href + '?' + params;
			}
			window.location.href = href;
		});
	}

    (function($) {

		/* Number animation */
			if ( $('.number-animation').length ) {
				$(window).scroll(scrollTrigger);
				var viewed = false;
			}
			function isScrolledIntoView(elem) {
				var docViewTop = $(window).scrollTop();
				var docViewBottom = docViewTop + $(window).height();
				var elemTop = $(elem).offset().top;
				var elemBottom = elemTop + 200/* $(elem).height() */;
				return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop))
			}
			function scrollTrigger() {
				setTimeout(function() {
					if (isScrolledIntoView($(".number-anim-wrapper")) && !viewed) {
						viewed = true;
						$('.number-animation').each(function () {
							$(this).fadeTo('slow', 1);
						});
						$('.number-anim-no').each(function () {
							$(this).prop('Counter',0).show().animate({
								Counter: $(this).text()
							}, {
								duration: 2000,
								easing: 'swing',
								step: function (now) {
									$(this).text(Math.ceil(now));
								}
							});
						});
					}
				}, 500);
			}

		})(jQuery);
});

//import "./aptumistic/responsive-background-image";
//import "./aptumistic/content-accordion";
//import "./aptumistic/helpers";
//import "./aptumistic/isotope";
import "./aptumistic/slide";
import "./aptumistic/popup";
